import {
  Button,
  Container,
  IconButton,
  Layout,
  Spacer,
  SvgClose,
  Text,
} from '@loomhq/lens';
import React from 'react';

import { track } from 'utilities/analytics';

import iosAppIcon from 'img/logos/ios-app-icon.svg';

import { CLICKED_IOS_SHARE_DOWNLOAD_APP } from '../../../constants/events';
import { APP_STORE } from '../../../constants/routes';

import styles from './styles.module.less';

const MobileAppCard = ({ onCloseClick }) => (
  <>
    <div className={styles.mobileAppCardWrapper}>
      <div className={styles.mobileAppCard}>
        <Layout>
          <Layout.Section width="auto">
            <Spacer left="medium" top="medium">
              <div className="flex">
                <img alt="Loom mobile app" src={iosAppIcon} />
              </div>
            </Spacer>
          </Layout.Section>
          <Layout.Section>
            <Spacer top="medium" left="medium" right="small">
              <Text fontWeight="bold" htmlTag="h2">
                Record, share, and watch on the go.
              </Text>
              <p className={styles.mobileAppCardDescription}>
                The fastest way to record and instantly share a video from your
                iPhone and iPad.
              </p>
            </Spacer>
          </Layout.Section>
          <Layout.Section width="auto">
            <Spacer right="small" top="small">
              <IconButton
                altText="Close"
                icon={<SvgClose />}
                onClick={onCloseClick}
              />
            </Spacer>
          </Layout.Section>
        </Layout>
        <Container padding="medium">
          <Button
            htmlTag="a"
            href={APP_STORE}
            variant="primary"
            onClick={e => {
              e.preventDefault(); // prevent using href on click, but we keep the href to still allow right-click to copy link
              track(CLICKED_IOS_SHARE_DOWNLOAD_APP, {}, () => {
                window.location.href = APP_STORE;
              });
            }}
            hasFullWidth
          >
            Download Loom for iOS
          </Button>
        </Container>
      </div>
    </div>
    <div className={styles.mobileAppCardSpacer} />
  </>
);

export default MobileAppCard;
